import React, { createContext, useContext, useEffect, useState } from 'react';
import BottomDrawer from './BottomDrawer';
import { getBottomDrawerStatus, getElementOnFocus } from '../../../../store/global/selectors';
import { useSelector } from 'react-redux';
import BottomDrawerContent from './BottomDrawerContent';

export const BottomDrawerContext = createContext();

export const useBottomDrawerContext = () => useContext(BottomDrawerContext);

export const BottomDrawerProvider = () => {

    const openDrawer = useSelector(getBottomDrawerStatus);
    const elementOnFocus = useSelector(getElementOnFocus);
    const screen =  elementOnFocus?.transaction !== "" && elementOnFocus?.transaction !== null ?  "transaction" : "";


    // Update/Create Button properties 
    const [showUpdateButton,    setShowUpdateButton] = useState(false);
    const [disableUpdate,       setDisableUpdate] = useState(false);
    const [updateButtonText,    setUpdateButtonText] = useState(false);
    const [onActionCompletion,  setOnActionCompletion] = useState(null);
    const [onActionClose,       setOnActionClose] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isEditing, setIsEding]  = useState(false);

    return ( openDrawer &&
        <BottomDrawerContext.Provider
            value={{
                showUpdateButton,
                disableUpdate,
                updateButtonText,
                onActionCompletion,
                onActionClose,
                isLoading,
                isEditing,
                setShowUpdateButton, 
                setDisableUpdate, 
                setUpdateButtonText,
                setOnActionCompletion,
                setOnActionClose,
            }}
        >
            <BottomDrawer screen={screen}><BottomDrawerContent/></BottomDrawer> 
        </BottomDrawerContext.Provider>
    );

};